export const FLAG_BOARDING_DRAFT_ACTIVITY = 'FLAG_BOARDING_DRAFT_ACTIVITY';

export const GET_MOVEMENT_REASONS = 'GET_MOVEMENT_REASONS';
export const CLEAR_MOVEMENT_REASONS = 'CLEAR_MOVEMENT_REASONS';
export const LOAD_MOVEMENT_REASONS = 'LOAD_MOVEMENT_REASONS';
